import { createSlice } from '@reduxjs/toolkit';

// Default admin user
const DEFAULT_ADMIN = {
  email: 'admin@admin.com',
  password: 'admin'
};

// Initialize admin users if not exists
if (typeof window !== 'undefined') {
  const adminUsers = JSON.parse(localStorage.getItem('admin_users') || '[]');
  if (adminUsers.length === 0) {
    localStorage.setItem('admin_users', JSON.stringify([DEFAULT_ADMIN]));
  }
}

const getStoredData = (key, defaultValue) => {
  try {
    const stored = localStorage.getItem(key);
    return stored ? JSON.parse(stored) : defaultValue;
  } catch (e) {
    return defaultValue;
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    userInfo: getStoredData('UserInfo', null),
    admin: getStoredData('Admin', null),
  },
  reducers: {
    lawyerLogin: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem('UserInfo', JSON.stringify(action.payload));
    },
    lawyerLogout: (state) => {
      state.userInfo = null;
      localStorage.removeItem('UserInfo');
      localStorage.removeItem('Project');
    },
    adminLogin: (state, action) => {
      state.admin = action.payload;
      localStorage.setItem('Admin', JSON.stringify(action.payload));
    },
    adminLogout: (state) => {
      state.admin = null;
      localStorage.removeItem('Admin');
    },
    clearUserInfo: (state) => {
      state.userInfo = null;
    },
    resetUserInfo: (state) => {
      state.userInfo = null;
    },
  },
});

export const {
  lawyerLogin,
  lawyerLogout,
  adminLogin,
  adminLogout,
  clearUserInfo,
  resetUserInfo,
} = authSlice.actions;

export default authSlice.reducer;

